import React, { useEffect, useState } from 'react';
import { ApolloProvider } from '@apollo/client/react';
import SnackbarAlert from '../../components/SnackbarAlert';
import queryString from 'query-string';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import './App.css';
import RoomUnderCleaningTabs from '../../components/RoomUnderCleaningTabs';
import { client } from '../../components/ApolloClient.js';
import { config } from '../../config';
import { appendCleaningAreas, setArea } from '../../state/actions-creators';
import { useAuth } from '../../hooks/useAuth';

const AppDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 480px;
  background-color: #fff;
`;

const LargeHeader = styled.h1`
  font-size: calc(1px + 7vmin);
`;

const Page = styled.div`
  width: 40vw;
`;

const RoomUnderCleaning = () => {
  const { token } = useAuth();
  const { cleaningAreas } = useSelector((state) => state);
  const dispatch = useDispatch();
  const parsed = queryString.parse(window.location.search);
  const params = new URL(document.location).searchParams;
  const pathIds = window.location.pathname.split('/');
  const orgId = params.get('organization') || pathIds[1];
  const locationId = params.get('location') || pathIds[2];

  const [apolloClient, setApolloClient] = useState();

  const checkLastEvent = (responseArea) => {
    /*  Check most recent event type (start/stop). 
          If start, save info of current cleaning progress.
    */
    fetch(`${config.lnt_api_url}/check`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        orgId: orgId,
        locationId: locationId,
        area: responseArea,
        token: token,
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.type === 'start') {
          if (cleaningAreas.includes(json.area) === false)
            dispatch(appendCleaningAreas(json.area));
        }
        return json.area;
      })
      .catch((err) => {
        console.log('Error in App.js, calling /v1/check');
        console.log(err);
      });
  };

  const findAreas = () => {
    /*  Get each area from DB for the organization/location */
    fetch(`${config.lnt_api_url}/find`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        orgId: orgId,
        locationId: locationId,
        token: token,
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        json.forEach((area) => checkLastEvent(area));
      })

      .catch((err) => {
        console.log('Error in App.js, calling /v1/find');
        console.log(err);
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetch(`${config.lnt_api_url}/init?id=${parsed.id}`, {
        /* Initialize app: Fetch area name from API */
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          orgId: orgId,
          locationId: locationId,
          token: token,
        }),
      })
        .then((res) => res.json())
        .then((json) => {
          dispatch(setArea(json.area));
          return json.area;
        })
        .catch((err) => {
          console.log('Error in App.js, calling /v1/type');
          console.log(err);
        });
      // Wait for initialize fetch to finish, then call
      findAreas();
    };
    fetchData();

    const initApolloClient = async () => {
      const apolloClient = await client;
      setApolloClient(apolloClient);
    };
    initApolloClient();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!apolloClient) return null;

  return (
    <ApolloProvider client={apolloClient}>
      <AppDiv>
        <LargeHeader>Room under cleaning App</LargeHeader>
        <Page>
          <RoomUnderCleaningTabs />
        </Page>
        <SnackbarAlert></SnackbarAlert>
      </AppDiv>
    </ApolloProvider>
  );
};

export default RoomUnderCleaning;
